import { Conditional } from 'iq-blueberry'
import './style.styl'
import * as classNames from 'classnames'

export function FormTitle({
  title,
  description,
  largeSize = false,
  hasRequiredFieldWarning = false,
  isRequiredStep = false,
  children,
}) {
  const componentClass = classNames('app-form-title__heading', {
    'app-form-title__heading--large-size': !!largeSize,
  })
  return (
    <div className={componentClass}>
      <h1 className="heading__title">{title}</h1>
      <p className="heading__text">
        {description}
        {children}
      </p>
      <Conditional
        condition={!!hasRequiredFieldWarning}
        renderIf={
          <p className="heading__warning">
            <span>*</span> Indica que o campo é obrigatório
          </p>
        }
      />
      <Conditional
        condition={!!isRequiredStep}
        renderIf={
          <p className="heading__warning">
            <span>*</span> Etapa obrigatória
          </p>
        }
      />
    </div>
  )
}
